import Persons from "./persons"
import Articles from "./articles"
import RelatedArticles from "./related-articles"
import Athletes from "./athletes"
import Interview from "./interview"
import Interviews from "./interviews"
import AllBooks from "./books-all"
import Book from "./book"
import Books from "./books"
import Images from "./images"
import Image from "./image"
import Foods from "./foods"
import Recipe from "./recipe"
import Recipes from "./recipes"
import TDEECalculator from "./TDEECalculator"
import ORMCalculator from "./ORMCalculator"
import AffiliateDisclaimer from "./affiliate-disclaimer"
import YoutubeVideo from "./youtube-video"
import MDXLink from "./mdx-link"
import ClearAlign from "./clear-align"
import CTAButton from "./CTAButton"

export default {
  Persons,
  Articles,
  RelatedArticles,
  Athletes,
  Interview,
  Interviews,
  AllBooks,
  Book,
  Books,
  YoutubeVideo,
  Images,
  Image,
  Foods,
  Recipe,
  Recipes,
  TDEECalculator,
  ORMCalculator,
  AffiliateDisclaimer,
  MDXLink,
  ClearAlign,
  CTAButton,
}
